import { render } from "./aboutUsComponent.vue?vue&type=template&id=7ec46e44"
import script from "./aboutUsComponent.vue?vue&type=script&lang=js"
export * from "./aboutUsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__